import Appsignal from "@appsignal/javascript";

export const appsignal = new Appsignal({
  key:
    process.env.NODE_ENV === "development"
      ? ""
      : process.env.NEXT_PUBLIC_APPSIGNAL_PUSH_API_KEY,
});
